import { assert_array_not_empty, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestTokensDelete extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_TOKENS_DELETE;

  entity_id!: string;
  words_english: string[];

  /*
   * METHODS
   */

  constructor(entity_id: string = '', word_ids: string[] = []) {
    super();

    this.entity_id = entity_id;
    this.words_english = word_ids;
  }

  assert_standard_fields(): void {
    assert_string_object_id(this.entity_id, { context: 'entity_id' });

    assert_array_not_empty(this.words_english);
  }
}
